"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractUseCase = void 0;
class ContractUseCase {
    constructor(contractAddress, method, params, isWrite) {
        this.contractAddress = contractAddress;
        this.method = method;
        this.params = params;
        this.isWrite = isWrite;
    }
    getCallValue() {
        return undefined;
    }
    getArgs() {
        return [];
    }
    execute(adapter, options = {}) {
        return adapter
            .execute(this.contractAddress, this.method, {
            args: this.getArgs(),
            callValue: this.getCallValue(),
            block: options.blockHeight,
        }, this.isWrite)
            .then(this.formatResponse.bind(this));
    }
    formatResponse(response) {
        return response;
    }
}
exports.ContractUseCase = ContractUseCase;
